<script>
import { Dropdown } from 'element-ui';

export default {
  extends: Dropdown,
  methods: {
    handleMenuItemClickAnalytics(command, instance) {
      if (instance.$el.attributes['data-analytics-id']?.value) {
        this.$store.dispatch('analytics/trackEvent', {
          analytics: {
            category: this.$route.name,
            action: 'click',
            label: instance.$el.attributes['data-analytics-id']?.value,
          },
        });
      }
    },
    handleVisibleChange(isVisible) {
      if (isVisible) {
        this.$el.classList.add('open');
      } else {
        this.$el.classList.remove('open');
      }
    },
  },
  mounted() {
    this.$on('menu-item-click', this.handleMenuItemClickAnalytics);
    this.$on('visible-change', this.handleVisibleChange);
  },
};
</script>
